import React from 'react'
import cx from 'classnames'

import styles from './Card.module.scss'

type CardProps = {
  children?: React.ReactNode
  className?: string
  tagName?: keyof React.JSX.IntrinsicElements | null
}

export const Card = ({ children, className, tagName = null }: CardProps) => {
  const Component = tagName ?? 'div'

  return (
    <Component className={cx(styles.card, className)}>{children}</Component>
  )
}
